import { PdfBatchGenerationComponent } from './pdf-batch-generation.component'
import { pdfBatchGenerationRoutes } from './pdf-batch-generation.routing'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from '../../shared/shared.module'
import { DataGenerationSectionModule } from '@components/data-generation-section/data-generation-section.module'
import { ContentLoadingModule } from '@components/content-loading/content-loading.module'
import { BreadcrumbsModule } from '@components/breadcrumbs/breadcrumbs.module'

@NgModule({
  declarations: [PdfBatchGenerationComponent],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(pdfBatchGenerationRoutes, {
      scrollPositionRestoration: 'top',
    }),
    HttpClientModule,
    SharedModule,
    DataGenerationSectionModule,
    ContentLoadingModule,
    BreadcrumbsModule,
  ],
  exports: [PdfBatchGenerationComponent],
})
export class PdfBatchGenerationModule {}
